import React from 'react';
import { MdOutlineCancel } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';

import { Button } from '.';
import { userProfileData } from '../data/dummy';
import { useStateContext } from '../contexts/ContextProvider';
import avatar from '../images/avatar.png';

import { logout } from '../utils/auth';

const UserProfile = ({ user }) => {
  const { currentColor } = useStateContext();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
  }

  return (
    <div className="nav-item absolute right-1 top-16 bg-white dark:bg-[#42464D] p-8 rounded-lg w-96">
      <div className="flex justify-between items-center">
        <p className="font-semibold text-lg dark:text-gray-200">User Profile</p>
        <Button
          icon={<MdOutlineCancel />}
          color="rgb(153, 171, 180)"
          bgHoverColor="light-gray"
          size="2xl"
          borderRadius="50%"
        />
      </div>
      <div className="flex gap-5 items-center mt-6 border-color border-b-1 pb-6">
        <img
          className="rounded-full h-24 w-24"
          src={avatar}
          alt="user-profile"
        />
        <div>
          <p className="font-semibold text-xl dark:text-gray-200"> { user.firstName + " " + user.lastName} </p>
          <p className="text-gray-500 text-sm dark:text-gray-400">  Administrator   </p>
          <p className="text-gray-500 text-sm font-semibold dark:text-gray-400"> { user.email } </p>
        </div>
      </div>
      <div>
        
      </div>
      <div className="mt-5">
      <button
          type="button"
          onClick={handleLogout}
          style={{ backgroundColor: currentColor,width: '100%', color: "white", borderRadius:"10px" }}
          className={` text-${12} p-3 hover:drop-shadow-xl `}
        >
         Logout
      </button>
      <br />
      <br />
      <button
          type="button"
          onClick={() => navigate(`/setting`)}
          style={{ backgroundColor: "#405B9B",width: '100%', color: "white", borderRadius:"10px" }}
          className={` text-${12} p-3 hover:drop-shadow-xl `}
        >
         View Profile
      </button>
    
      </div>
    </div>

  );
};

export default UserProfile;
